import SubscriptionsWithGroups from "./SubscriptionsWithGroups"

export default  SubscriptionsWithGroups;



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionsWithGroups/index.js